import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { formsV2 as Forms } from '@breezeway/brzw-components';
import { phoneNumberUtils } from '../../../../utils';

const replaceInvalidCharacters = value => value.replace(/[^(0-9)\-+() ]/g, '');

const PhoneSelectFormik = ({
  additionalProps,
  className,
  disabled,
  field,
  form,
  inputProps,
  size,
}) => {
  const { errors, setFieldValue, submitCount, touched } = form;
  const { name } = field;
  let hasError = false;
  let errorText = null;
  const shouldHandleError = (touched[name] || submitCount > 0) && errors[name];
  const countryCode = _.get(_.head(field.value), 'country_code');
  const phoneNumber = _.get(_.head(field.value), 'phone_number');
  const fieldName = _.get(field, 'name');

  if (shouldHandleError) {
    hasError = true;
    errorText = errors[name];
  }

  const onChange = (value, { dialCode, iso2 }) =>
    setFieldValue(field.name, [
      {
        country_code: iso2,
        dial_code: dialCode,
        phone_number: replaceInvalidCharacters(value),
      },
    ]);

  const onChangeCountry = (value, { dialCode, iso2 }) => {
    onChange(phoneNumberUtils.getFormattedNumberWithoutCountryCode(value, iso2, dialCode), {
      dialCode,
      iso2,
    });
  };

  return (
    <Forms.PhoneSelect
      additionalSubText={hasError && errorText}
      className={className}
      countryValue={countryCode}
      disabled={disabled}
      id={fieldName}
      onChange={onChange}
      phoneValue={phoneNumber}
      placeholderText="(201) 555-01234"
      iconAfter="warning"
      inputProps={{
        ...inputProps,
        onSelectFlag: onChangeCountry,
      }}
      size={size}
      withError={hasError}
      {...additionalProps}
    />
  );
};

PhoneSelectFormik.propTypes = {
  additionalProps: PropTypes.shape({}),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.array,
  }),
  form: PropTypes.shape({}),
  inputProps: PropTypes.shape({}),
  size: PropTypes.string,
};

PhoneSelectFormik.defaultProps = {
  disabled: false,
  inputProps: {
    allowUpdateFlagFromNumber: false,
    format: true,
    formatOnInit: true,
    nationalMode: true,
  },
};

export default PhoneSelectFormik;
